import { useEffect, useState } from 'react';
import { useErrorStore } from '../../store/models';

import Validations, { validate } from '../../utils/validations';

const messages = {

    password: {
        required: 'Password is required',
        minLength: 'Password mininum length is 8',
        maxLength: 'Password maximum length is 32',
        pattern: 'Your password needs contain one uppercase letter, a special character and a number.',
    },

    code: {
        required: 'Verification code is required.',
        minLength: 'Verification code mininum length is 6',
        maxLength: 'Verification code maximum length is 6',
        pattern: 'Verification code only accept numerical input.',
    },

};

function useForgotPasswordError (props) {
    const {
        input,
    } = props;
    const errStore = useErrorStore();
    const [touched, setTouched] = useState({});
    const [_input, setInput] = useState(input);
    const [error, setError] = useState({
        code: '',
        password: '',
        disableSend: true,
    });

    function validateByChange () {
        const err = {
            code: validateCode(),
            password: validatePassword(),
        };

        if (err.code || err.password) {
            err.disableSend = true;
        } else {
            err.disableSend = false;
        }
        setError(err);
    }

    function validatePassword () {
        if (!touched.password) {
            return '';
        }
        return validate({
            rules: { ...Validations.password },
            messages: messages.password,
            value: _input.password,
        });
    }

    function validateCode () {
        if (!touched.code) {
            return '';
        }
        return validate({
            rules: { ...Validations.verificationCode },
            messages: messages.code,
            value: _input.code,
        });
    }

    function touchInputs () {
        const t = { ...touched };
        for (const p in input) {
            if (input[p] && t[p] !== true) {
                t[p] = true;
            }
        }
        setTouched(t);
    }

    useEffect(() => {
        touchInputs();
        setInput(input);
    }, [input]);

    useEffect(() => {
        if (Object.entries(touched).length > 0) {
            validateByChange();
        }
    }, [_input]);

    useEffect(() => {
        if (errStore.authError.recoverPassword) {
            setError({
                ...errStore.authError.recoverPassword,
            });
        }
    }, [errStore.authError.recoverPassword]);

    return {
        error,
    };
}

export default useForgotPasswordError;
